<template>
  <div class="space-y-6">
    <!-- 返回按钮和标题 -->
    <div class="flex items-center space-x-4">
      <button
        @click="$router.go(-1)"
        class="text-gray-400 hover:text-gray-600"
      >
        <ArrowLeftIcon class="h-6 w-6" />
      </button>
      <div>
        <h1 class="text-2xl font-bold text-gray-900">客户详情</h1>
        <p class="mt-1 text-sm text-gray-500">查看和编辑客户信息</p>
      </div>
    </div>

    <!-- 客户详情 -->
    <div class="bg-white shadow-sm rounded-lg border border-gray-200">
      <div class="px-6 py-4 border-b border-gray-200">
        <h3 class="text-lg font-medium text-gray-900">客户信息</h3>
      </div>
      <div class="p-8 text-center text-gray-500">
        <UsersIcon class="mx-auto h-12 w-12 text-gray-400" />
        <p class="mt-2">客户详情正在开发中...</p>
        <p class="text-sm">客户ID: {{ $route.params.id }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ArrowLeftIcon, UsersIcon } from '@heroicons/vue/24/outline'
</script>
